import { useEffect, useState } from "react"
import { useTraduction } from "../../Contexte/TraductionContext";

function Temoignage() {
    const { contentAccueil } = useTraduction()
    const temoignage = contentAccueil.Temoignage
    const [CoulissantValue, setCoulissantValue] = useState(0)

    useEffect(() => {
        const transformPorcent = 0
        setCoulissantValue(transformPorcent)
    
        // Vérification et ajout de la classe active à la première span
        const firstSpan = document.querySelector('.Menu span:first-child');
        if (firstSpan) {
            firstSpan.classList.add("active");
        }
    }, [temoignage.length]);
    
    const handleClick = (event) =>{
        const Targetid = event.target.id
        const Span = document.querySelectorAll(`.Menu span`);
        if(Span){
            Span.forEach(item => {
                item.classList.remove("active")
            });
        }
        event.target.classList.add("active")

        const transformPorcent = ((100 / temoignage.length) * Targetid)
        setCoulissantValue(transformPorcent)

    }

    return <>

    <section id="Temoignage" className="container mt-124">
        <div className="ContainerTop">
            <div className="coulissant" style={{transform: `translateX(-${CoulissantValue}%)`}}>
            {contentAccueil.Temoignage && contentAccueil.Temoignage.map(item => (
                <div className="temoignage container">
                    <div className="containerIMG">
                        <img loading="lazy" src={"../../../Assets/visuels/images/home/customer/" + item.logo + ".webp"} alt={item.logo} />
                    </div>
                    <div className="container-content">
                        <p className="Poste">{item.poste}</p>
                        <p className="Nom">{item.nom}</p>
                        <p className="Avis mt-32">{item.avis}</p>
                    </div>
                </div>
            ))}
            </div>
        </div>
        <div className="Menu">
            {temoignage.map((item, index) => (
                <span id={index} onClick={handleClick}></span>
            ))}
        </div>
    </section>
</>
}

export default Temoignage